'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var iconBase = {
  width: 10,
  height: 14
};

var CaretLeft = function (_PureComponent) {
  _inherits(CaretLeft, _PureComponent);

  function CaretLeft() {
    _classCallCheck(this, CaretLeft);

    return _possibleConstructorReturn(this, (CaretLeft.__proto__ || Object.getPrototypeOf(CaretLeft)).apply(this, arguments));
  }

  _createClass(CaretLeft, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          color = _props.color,
          size = _props.size,
          block = _props.block;

      var newSize = (0, _utils.calcIconSize)(iconBase, size);

      return _react2.default.createElement(
        'svg',
        {
          className: (0, _utils.baseClassname)('caret-left') + ' ' + (block ? 'db' : ''),
          width: newSize.width,
          height: newSize.height,
          viewBox: '0 0 10 14',
          fill: 'none',
          xmlns: 'http://www.w3.org/2000/svg' },
        _react2.default.createElement('path', {
          d: 'M7.72356 8.48154C7.32958 8.89452 6.67042 8.89452 6.27644 8.48154L0 1.90235L1.81481 0L7 5.43529L12.1852 0L14 1.90235L7.72356 8.48154Z',
          transform: 'translate(9.23999) rotate(90)',
          fill: color
        })
      );
    }
  }]);

  return CaretLeft;
}(_react.PureComponent);

CaretLeft.defaultProps = {
  color: 'currentColor',
  size: 16,
  block: false
};

CaretLeft.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.number,
  block: _propTypes2.default.bool
};

exports.default = CaretLeft;